import { render, staticRenderFns } from "./BaseComponent.vue?vue&type=template&id=65550ddf&scoped=true"
import script from "./BaseComponent.vue?vue&type=script&lang=js"
export * from "./BaseComponent.vue?vue&type=script&lang=js"
import style0 from "./BaseComponent.vue?vue&type=style&index=0&id=65550ddf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65550ddf",
  null
  
)

export default component.exports